import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import {bindActionCreators} from 'redux';
import style from './style.scss';
// Redux actions
import actionSetEmojiContainerIsDisplayed
    from '/chat/src/redux/actions/emoji/actionSetEmojiContainerIsDisplayed';

import ChatEmojiIcon from '/chat/src/components/SVGImages/ChatEmojiIcon'


class ChatFooterEmojiButton extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            hover: false,
            isActive: props.emoji.get('isEmojiContainerDisplayed')
        };
        this.handleClick = this.handleClick.bind(this);
    }
    onHover (e) {
        this.setState({hover: true})
    }
    onHoverLeave (e){
        if(!this.state.isActive){
            this.setState({hover:false})
        }
    }
    componentWillReceiveProps(nextProps){
        this.setState({
            isActive: nextProps.emoji.get('isEmojiContainerDisplayed')
        })
    }
    render()
    {
        return (
            <div onClick={this.handleClick}
                onMouseEnter={this.onHover.bind(this)}
                onMouseLeave={this.onHoverLeave.bind(this)}
                className={style.ChatFooterEmojiButton}>
                <ChatEmojiIcon active={this.state.hover} color={this.props.color}/>
            </div>

        );
    }

    handleClick()
    {
        this.toggleEmojiContainerDisplay();
    }

    toggleEmojiContainerDisplay()
    {
        this.props.actionSetEmojiContainerIsDisplayed(!this.state.isActive);
    }
}

function mapStateToProps(state)
{
    return {
        emoji: state.get('emoji')
    };
}

function matchDispatchToProps(dispatch)
{
    return bindActionCreators({
        actionSetEmojiContainerIsDisplayed: actionSetEmojiContainerIsDisplayed

    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(ChatFooterEmojiButton);



// WEBPACK FOOTER //
// ./routes/Chat/Chat/ChatFooter/ChatFooterEmojiButton.js